import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../assets/css/Styles1.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hseq from '../components/hseq';
import { useNotification } from '../components/NotificationSystem';
import SEO from '../components/SEO';
import Icon from '../components/Icon';

function HseqEvaluation({ onLogout, userRole }) {
  const { success, error: showError, warning } = useNotification();
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [evaluatedSet, setEvaluatedSet] = useState(new Set());
  const [hseqGlobalMap, setHseqGlobalMap] = useState({});
  const [searchText, setSearchText] = useState('');
  const [isDashboardCollapsed, setIsDashboardCollapsed] = useState(false);
  const evaluationRef = useRef(null);
  // HSEQ es anual (suele hacerse hacia octubre). El bloqueo es por año.
  // Al guardar se usa AAAA-MM para enlazar con la evaluación de desempeño del mes.
  const anioActual = useMemo(() => String(new Date().getFullYear()), []);
  const periodoGuardado = useMemo(() => (
    `${anioActual}-${String(new Date().getMonth() + 1).padStart(2, '0')}`
  ), [anioActual]);

  const perteneceAlAnioActual = (periodo) => {
    const p = String(periodo || '');
    return p === anioActual || p.startsWith(`${anioActual}-`);
  };

  const aplicarEstadoHseqAnual = (rows) => {
    const map = {};
    const idsAnio = [];
    (rows || []).forEach((r) => {
      const key = Number(r.id_empleado);
      if (!perteneceAlAnioActual(r.periodo_evaluacion)) return;
      map[key] = r;
      idsAnio.push(key);
    });
    setHseqGlobalMap(map);
    setEvaluatedSet(new Set(idsAnio));
  };

  const [hseqItems, setHseqItems] = useState([
    { id: 1,  responsabilidad: 'Procurar el cuidado integral de su salud.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 2,  responsabilidad: 'Suministrar información clara, veraz y completa sobre su estado de salud.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 3,  responsabilidad: 'Cumplir las normas, reglamentos e instrucciones del Sistema de Gestión Integral de la empresa.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 4,  responsabilidad: 'Informar oportunamente al empleador o contratante acerca de los riesgos y/o peligros latentes en el desempeño de sus funciones y en su sitio de trabajo, colaborando en los planes de acción para sus posibles tratamientos.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 5,  responsabilidad: 'Participar en las actividades de capacitación y entrenamiento definidas en el programa de capacitación anual de la compañía y en las demás actividades HSEQ que se realicen mostrando así su compromiso con el Sistema de Gestión Integral de la Compañía.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 6,  responsabilidad: 'Participar y contribuir al cumplimiento de los objetivos del Sistema de Gestión Integral.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 7,  responsabilidad: 'Conocer, aplicar e interiorizar las políticas HSEQ, demostrando su compromiso con la compañía.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 8,  responsabilidad: 'Reportar oportunamente actos y condiciones inseguras que generen accidentes e incidentes laborales y ambientales.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 9,  responsabilidad: 'Garantizar el cumplimiento y el control de la información documentada establecida para las diferentes actividades que se generen en la compañía y para el óptimo desarrollo de sus funciones, velando así por la disponibilidad y seguridad de la información.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 10, responsabilidad: 'Garantizar la satisfacción del cliente brindando un alto estándar de calidad en el servicio prestado.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 11, responsabilidad: 'Participar en la evaluación del cumplimiento de los aspectos HSEQ de sus colaboradores.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 12, responsabilidad: 'Portar y utilizar los elementos de protección personal requeridos, velando por su cuidado y la utilización adecuada y permanente de sus colaboradores y reportar cualquier daño en los mismos.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 13, responsabilidad: 'Participar y colaborar con las auditorias (internas y externas) del Sistema Integrado de Gestión de MERIDIAN CONSULTING.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 14, responsabilidad: 'Reducir el consumo de papel en las actividades cotidianas inherentes a su cargo y hacer uso moderado del recurso hídrico y eléctrico, y en general cualquier recurso ambiental demostrando su compromiso con el SGA de MERIDIAN CONSULTING.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 15, responsabilidad: 'Realizar la disposición adecuada de los residuos sólidos y peligrosos generados por su labor de acuerdo con lo establecido por MERIDIAN CONSULTING LTDA. o por el cliente.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 16, responsabilidad: 'Solicitar los recursos económicos, técnicos y humanos para garantizar condiciones óptimas de trabajo, logrando así la protección integral del trabajador y el medio que lo rodea.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 17, responsabilidad: 'Participar cuando se ha requerido en la investigación de los incidentes, accidentes de trabajo y enfermedad laboral asociados a su proyecto.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 18, responsabilidad: 'Participar en simulacros, elección de COPASST y elección de comité de convivencia.', evaluacionJefe: '', justificacionJefe: '' },
    { id: 19, responsabilidad: 'Cumplir con las funciones y responsabilidades asignadas de ser elegido miembro del COPASST, Comité de convivencia laboral y/o comité de emergencias.', evaluacionJefe: '', justificacionJefe: '' },
  ]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const envBase = process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL.trim();
        const fallbackBase = `${window.location.protocol}//${window.location.hostname}/Evaluacion/backend`;
        const apiBase = envBase || fallbackBase;
        // Último HSEQ por empleado; el front filtra solo los del año actual
        const [empRes, hseqRes] = await Promise.all([
          fetch(`${apiBase}/api/employees`),
          fetch(`${apiBase}/api/evaluations/hseq-evaluated/all`)
        ]);

        const empCt = (empRes.headers.get('content-type') || '').toLowerCase();
        if (!empRes.ok || !empCt.includes('application/json')) {
          throw new Error(`Empleados HTTP ${empRes.status}`);
        }
        const empJson = await empRes.json();
        const empList = (empJson && (empJson.data || empJson)) || [];
        setEmployees(Array.isArray(empList) ? empList : []);

        if (hseqRes) {
          const hseqCt = (hseqRes.headers.get('content-type') || '').toLowerCase();
          if (!hseqRes.ok || !hseqCt.includes('application/json')) {
            throw new Error(`HSEQ HTTP ${hseqRes.status}`);
          }
          const hseqJson = await hseqRes.json();
          aplicarEstadoHseqAnual((hseqJson && (hseqJson.data || [])) || []);
        }
      } catch (e) {
        setError('No se pudo cargar empleados');
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [anioActual]);

  const handleHseqChange = (id, field, value) => {
    setHseqItems(prev => prev.map(it => it.id === id ? { ...it, [field]: value } : it));
  };

  const handleHseqJustificacionChange = (id, field, value) => {
    setHseqItems(prev => prev.map(it => it.id === id ? { ...it, [field]: value } : it));
  };

  const calcularPromedioHseq = () => {
    let suma = 0;
    let count = 0;
    hseqItems.forEach(it => {
      // Excluir cualquier item marcado como "No Aplica"
      if (it.evaluacionJefe === 'NA') {
        return; // No incluir en el cálculo del promedio
      }
      
      const v = Number(it.evaluacionJefe) || 0;
      if (v > 0) { suma += v; count += 1; }
    });
    return count ? (suma / count).toFixed(2) : 0;
  };

  const getHseqErrorStyle = () => ({});

  const pendientes = useMemo(() => employees.filter(emp => !evaluatedSet.has(Number(emp.id_empleado))), [employees, evaluatedSet]);
  const evaluados = useMemo(() => employees.filter(emp => evaluatedSet.has(Number(emp.id_empleado))), [employees, evaluatedSet]);

  const totalEmpleados = employees.length;
  const evaluadosGlobal = useMemo(() => Object.keys(hseqGlobalMap).length, [hseqGlobalMap]);
  const pendientesGlobal = Math.max(0, totalEmpleados - evaluadosGlobal);
  const porcentajeCompletado = totalEmpleados ? Math.round((evaluadosGlobal / totalEmpleados) * 100) : 0;
  const porcentajePendiente = 100 - porcentajeCompletado;

  const empleadosFiltrados = useMemo(() => {
    const q = searchText.trim().toLowerCase();
    if (!q) return employees;
    return employees.filter(emp => String(emp.nombre || '').toLowerCase().includes(q) || String(emp.cedula || '').includes(q));
  }, [employees, searchText]);

  const goToEvaluate = (emp) => {
    if (emp && evaluatedSet.has(Number(emp.id_empleado))) {
      warning('Evaluación ya realizada', `La evaluación HSEQ de este empleado ya fue realizada en ${anioActual}.`);
      return;
    }
    
    setSelectedEmployee(emp || null);
    setIsDashboardCollapsed(true);
    setTimeout(() => {
      if (evaluationRef.current) {
        evaluationRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);
  };

  const cancelarEvaluacion = () => {
    setSelectedEmployee(null);
    setIsDashboardCollapsed(false);
    setHseqItems(prev => prev.map(item => ({
      ...item,
      evaluacionJefe: '',
      justificacionJefe: ''
    })));
  };

  // Función para validar la evaluación HSEQ
  const validarEvaluacionHseq = () => {
    if (!selectedEmployee) {
      warning('Selección requerida', 'Debe seleccionar un empleado para evaluar.');
      return false;
    }

    // Verificar si el empleado ya fue evaluado este año
    if (evaluatedSet.has(Number(selectedEmployee.id_empleado))) {
      warning('Evaluación ya realizada', `La evaluación HSEQ de este empleado ya fue realizada en ${anioActual}.`);
      return false;
    }

    // Validación de permisos HSEQ eliminada - cualquier usuario con acceso a esta vista puede realizar evaluaciones HSEQ

    // Validar que todas las calificaciones estén completas (excepto items marcados como "No Aplica")
    const calificacionesFaltantes = hseqItems.filter(item => {
      // Si está marcado como "No Aplica", no es requerido
      if (item.evaluacionJefe === 'NA') {
        return false;
      }
      // Para todos los demás items, verificar que tengan calificación
      return !item.evaluacionJefe || item.evaluacionJefe === '' || item.evaluacionJefe === '0';
    });

    if (calificacionesFaltantes.length > 0) {
      warning('Calificaciones incompletas', `Debe calificar todas las responsabilidades HSEQ. Faltan ${calificacionesFaltantes.length} calificaciones.`);
      return false;
    }

    return true;
  };

  // Función para enviar la evaluación HSEQ
  const handleSubmitHseqEvaluation = async () => {
    if (!validarEvaluacionHseq()) {
      return;
    }

    try {
      setIsSubmitting(true);
      const envBase = process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL.trim();
      const fallbackBase = `${window.location.protocol}//${window.location.hostname}/Evaluacion/backend`;
      const apiBase = envBase || fallbackBase;
      
      // Preparar datos para enviar
      const formData = new FormData();
      formData.append('employeeId', selectedEmployee.id_empleado);
      formData.append('hseqData', JSON.stringify(hseqItems));
      formData.append('promedioHseq', calcularPromedioHseq());
      formData.append('periodoEvaluacion', periodoGuardado);
      
      // Obtener ID del evaluador HSEQ desde localStorage
      const evaluadorId = localStorage.getItem('employeeId');
      const evaluadorNombre = localStorage.getItem('employeeName');
      
      if (evaluadorId) {
        formData.append('evaluatorId', evaluadorId);
      }
      
      // Configurar firma del Coordinador HSEQ (Luis Guevara) independientemente de quién ejecute la evaluación
      formData.append('signatureName', 'Luis Guevara');
      formData.append('signatureTitle', 'Coordinador HSEQ');
      
      // Registrar el evaluador actual
      if (evaluadorNombre) {
        formData.append('evaluatorName', evaluadorNombre);
        formData.append('evaluatorRole', 'HSEQ');
      }

      const response = await fetch(`${apiBase}/api/evaluations/save-hseq`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        success('¡Evaluación HSEQ completada!', 'La evaluación HSEQ ha sido guardada exitosamente.');
        
        // Limpiar formulario después del éxito
        setHseqItems(prev => prev.map(item => ({
          ...item,
          evaluacionJefe: '',
          justificacionJefe: ''
        })));
        setSelectedEmployee(null);
        setIsDashboardCollapsed(false);
        
        // Recargar estado HSEQ del año actual
        try {
          const hseqRes = await fetch(`${apiBase}/api/evaluations/hseq-evaluated/all`);
          if (hseqRes.ok) {
            const hseqCt = (hseqRes.headers.get('content-type') || '').toLowerCase();
            if (hseqCt.includes('application/json')) {
              const hseqJson = await hseqRes.json();
              aplicarEstadoHseqAnual((hseqJson && (hseqJson.data || [])) || []);
            }
          }
        } catch (e) {
          // Si falla la recarga, no es crítico
          console.error('Error al recargar evaluaciones HSEQ:', e);
        }
      } else {
        const errorMessage = data.error ? 
          `Error: ${data.error}` : 
          `Error al guardar: ${data.message || 'Error desconocido'}`;
        showError('Error al guardar', errorMessage);
      }
    } catch (error) {
      showError('Error de conexión', 'Error al guardar la evaluación HSEQ. Intente nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <SEO 
        title="Evaluación HSEQ - Seguridad, Salud y Medio Ambiente"
        description="Sistema de evaluación HSEQ (Salud, Seguridad, Medio Ambiente y Calidad) de Meridian Consulting LTDA. Evalúa el cumplimiento de estándares de seguridad y calidad en el trabajo."
        keywords="evaluación HSEQ, seguridad laboral, salud ocupacional, medio ambiente, calidad, Meridian Consulting, evaluación seguridad"
        url="https://evaluacion.meridianltda.com/hseq-evaluation"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Evaluación HSEQ - Seguridad, Salud y Medio Ambiente",
          "description": "Sistema de evaluación HSEQ para Meridian Consulting LTDA",
          "url": "https://evaluacion.meridianltda.com/hseq-evaluation",
          "isPartOf": {
            "@type": "WebSite",
            "name": "Sistema de Evaluación de Desempeño - Meridian Consulting LTDA",
            "url": "https://evaluacion.meridianltda.com"
          },
          "about": {
            "@type": "Thing",
            "name": "Evaluación HSEQ (Salud, Seguridad, Medio Ambiente y Calidad)"
          }
        }}
      />
      <div className="hseq-evaluation-page">
      <Header onLogout={onLogout} userRole={userRole} />
      <main className="evaluation-container-unique" style={{ padding: 'clamp(1rem, 5vw, 2rem)', flex: 1 }}>
        <style>{`
          .hseq-card { 
            max-width: 1100px; 
            margin: 0 auto; 
            background: #ffffff; 
            border-radius: 12px; 
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
            overflow: hidden;
          }
          .hseq-card-header {
            background: linear-gradient(90deg, #1F3B73 0%, #0A0F1A 100%);
            color: #fff;
            padding: 16px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .hseq-card-title {
            font-size: 1.25rem;
            font-weight: 700;
            margin: 0;
          }
          .hseq-body { padding: 18px 20px; }
          .hseq-toolbar { 
            display: grid; 
            grid-template-columns: 1fr; 
            gap: 12px; 
            margin-bottom: 16px; 
          }
          .hseq-field { display: flex; flex-direction: column; gap: 6px; }
          .hseq-label { font-weight: 600; color: #1f2937; }
          .hseq-select { 
            appearance: none;
            width: 100%;
            padding: 10px 12px;
            background: #f9fafb; 
            border: 1px solid #e5e7eb; 
            border-radius: 8px; 
            outline: none; 
            transition: box-shadow .2s ease, border-color .2s ease; 
          }
          .hseq-select:focus { 
            border-color: #1F3B73; 
            box-shadow: 0 0 0 4px rgba(31, 59, 115, 0.12);
            background: #ffffff;
          }
          .hseq-employee-info { 
            display: flex; 
            flex-wrap: wrap; 
            gap: 10px; 
            padding: 12px; 
            border: 1px solid #e5e7eb; 
            border-radius: 10px; 
            background: #f8fafc; 
            margin-bottom: 14px; 
          }
          .hseq-badge { 
            display: inline-flex; 
            align-items: center; 
            gap: 6px; 
            background: #eef2ff; 
            color: #1f3b73; 
            font-weight: 600; 
            border-radius: 9999px; 
            padding: 6px 12px; 
            border: 1px solid rgba(31,59,115,.15);
          }
          @media (min-width: 720px) { 
            .hseq-toolbar { grid-template-columns: 1fr 1fr; }
          }
          /* Asegurar footer pegado al fondo */
          .hseq-evaluation-page { min-height: 100vh; display: flex; flex-direction: column; }
          /* Dashboard */
          .hseq-stats { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin: 14px 0; }
          .hseq-stat { background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px; }
          .hseq-stat-title { color: #6b7280; font-size: 12px; font-weight: 600; }
          .hseq-stat-value { color: #111827; font-size: 20px; font-weight: 800; }
          .hseq-progress { height: 8px; background: #eef2ff; border-radius: 999px; overflow: hidden; }
          .hseq-progress-bar { height: 100%; background: linear-gradient(90deg, #1F3B73, #0A0F1A); }
          .hseq-dash-table { width: 100%; border-collapse: collapse; }
          .hseq-dash-table th { text-align: left; font-size: 12px; color: #374151; background: #f3f4f6; padding: 10px; }
          .hseq-dash-table td { font-size: 14px; padding: 10px; border-bottom: 1px solid #f1f5f9; }
          .badge { display:inline-flex; align-items:center; gap:6px; padding:4px 10px; border-radius:999px; border:1px solid transparent; font-size:12px; font-weight:700; }
          .badge-ok { background:#ecfdf5; color:#065f46; border-color:rgba(16,185,129,.25); }
          .badge-pend { background:#fefce8; color:#92400e; border-color:rgba(245,158,11,.25); }
          .dash-header { display:flex; flex-direction: column; align-items:center; gap: 10px; }
          .search-wrap { position: relative; width: min(520px, 100%); margin: 0 auto; }
          .search-input { width:100%; height:40px; padding:0 12px 0 38px; border:1px solid #e5e7eb; border-radius:999px; background:#fff; outline:none; transition: box-shadow .2s ease, border-color .2s ease; }
          .search-input::placeholder { color:#94a3b8; }
          .search-input:focus { border-color:#1F3B73; box-shadow:0 0 0 4px rgba(31,59,115,.12); }
          .search-icon { position:absolute; left:12px; top:50%; transform: translateY(-50%); width:18px; height:18px; opacity:.7; }
          .dash-toggle { background:none; border:none; color:#1F3B73; font-weight:700; cursor:pointer; }
          @media (min-width: 900px) { .hseq-stats { grid-template-columns: repeat(4, 1fr); } }
        `}</style>

        <div className="hseq-card">
          <div className="hseq-card-header">
            <h1 className="hseq-card-title">Evaluación HSEQ</h1>
          </div>
          <div className="hseq-body">
            {loading && <p>Cargando empleados...</p>}
            {error && <p style={{ color: '#dc2626' }}>{error}</p>}

            {!loading && !error && (
              <div className="hseq-toolbar">
                <div className="hseq-field">
                  <label className="hseq-label">Seleccione empleado</label>
                  <select
                    className="hseq-select"
                    value={selectedEmployee?.id_empleado || ''}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (!val) {
                        cancelarEvaluacion();
                        return;
                      }
                      const emp = employees.find(x => String(x.id_empleado) === String(val));
                      if (emp) goToEvaluate(emp);
                    }}
                  >
                    <option value="">-- Seleccione --</option>
                    {pendientes.length > 0 && (
                      <optgroup label="Pendientes">
                        {pendientes.map(emp => (
                          <option key={`p-${emp.id_empleado}`} value={emp.id_empleado}>{emp.nombre}</option>
                        ))}
                      </optgroup>
                    )}
                    {evaluados.length > 0 && (
                      <optgroup label="Evaluados HSEQ">
                        {evaluados.map(emp => (
                          <option key={`e-${emp.id_empleado}`} value={emp.id_empleado}>{emp.nombre} (evaluado)</option>
                        ))}
                      </optgroup>
                    )}
                  </select>
                  <span style={{ fontSize: '12px', color: '#6b7280' }}>Evaluación anual {anioActual}</span>
                </div>
              </div>
            )}

            {selectedEmployee && (
              <>
                <div ref={evaluationRef} className="hseq-employee-info" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    <span className="hseq-badge">
                      <span>Empleado:</span> {selectedEmployee.nombre}
                    </span>
                    <span className="hseq-badge" style={{ background: evaluatedSet.has(Number(selectedEmployee.id_empleado)) ? '#ecfdf5' : '#fefce8', color: evaluatedSet.has(Number(selectedEmployee.id_empleado)) ? '#065f46' : '#92400e', borderColor: evaluatedSet.has(Number(selectedEmployee.id_empleado)) ? 'rgba(16,185,129,.25)' : 'rgba(245,158,11,.25)'}}>
                      {evaluatedSet.has(Number(selectedEmployee.id_empleado)) ? 'HSEQ: Completada' : 'HSEQ: Pendiente'}
                    </span>
                    <span className="hseq-badge" style={{ background: '#e0f2fe', color: '#0369a1', borderColor: 'rgba(3,105,161,.25)' }}>
                      <span>Evaluador:</span> {localStorage.getItem('employeeName') || 'Usuario'}
                    </span>
                    <span className="hseq-badge" style={{ background: '#f0f9ff', color: '#1e40af', borderColor: 'rgba(30,64,175,.25)' }}>
                      <span>Firma:</span> Luis Guevara (Coordinador HSEQ)
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={cancelarEvaluacion}
                    disabled={isSubmitting}
                    style={{
                      background: '#fff',
                      color: '#374151',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      padding: '8px 14px',
                      fontSize: '14px',
                      fontWeight: 600,
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Cancelar / Cambiar empleado
                  </button>
                </div>
                <Hseq
                  hseqItems={hseqItems}
                  handleHseqChange={handleHseqChange}
                  handleHseqJustificacionChange={handleHseqJustificacionChange}
                  calcularPromedioHseq={calcularPromedioHseq}
                  getHseqErrorStyle={getHseqErrorStyle}
                />

                <div style={{
                  textAlign: 'center',
                  marginTop: '24px',
                  padding: '20px',
                  borderTop: '1px solid #e5e7eb'
                }}>
                  <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center' }}>
                    <button
                      type="button"
                      onClick={cancelarEvaluacion}
                      disabled={isSubmitting}
                      style={{
                        background: '#fff',
                        color: '#374151',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: isSubmitting ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={handleSubmitHseqEvaluation}
                      disabled={isSubmitting}
                      style={{
                        background: isSubmitting
                          ? '#9ca3af'
                          : 'linear-gradient(135deg, #1F3B73, #0A0F1A)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 32px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        boxShadow: isSubmitting
                          ? 'none'
                          : '0 4px 12px rgba(31, 59, 115, 0.3)',
                        transition: 'all 0.3s ease',
                        opacity: isSubmitting ? 0.7 : 1
                      }}
                      onMouseOver={(e) => {
                        if (!isSubmitting) {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 6px 16px rgba(31, 59, 115, 0.4)';
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!isSubmitting) {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 4px 12px rgba(31, 59, 115, 0.3)';
                        }
                      }}
                    >
                      {isSubmitting ? (
                        <>
                          <div style={{
                            width: '16px',
                            height: '16px',
                            border: '2px solid #ffffff',
                            borderTop: '2px solid transparent',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                          }}></div>
                          Guardando...
                        </>
                      ) : (
                        <>
                          <Icon name="clipboard" size={16} />
                          Enviar Evaluación HSEQ
                        </>
                      )}
                    </button>
                  </div>

                  <div style={{
                    marginTop: '12px',
                    fontSize: '14px',
                    color: '#6b7280',
                    fontWeight: '500'
                  }}>
                    Promedio actual: <strong style={{ color: '#1F3B73' }}>{calcularPromedioHseq()}</strong>
                  </div>
                </div>
              </>
            )}

            {/* Dashboard HSEQ */}
            {!loading && !error && !selectedEmployee && !isDashboardCollapsed && (
              <div style={{ marginTop: '10px' }}>
                <div className="dash-header" style={{ marginBottom:'8px' }}>
                  <h2 style={{ fontSize:'1rem', margin:0, color:'#111827' }}>Dashboard HSEQ</h2>
                  <div className="search-wrap">
                    <svg className="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" stroke="#1F3B73" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <input
                      className="search-input"
                      placeholder="Buscar por nombre o cédula"
                      value={searchText}
                      onChange={(e)=>setSearchText(e.target.value)}
                    />
                  </div>
                </div>
                <div className="hseq-stats">
                  <div className="hseq-stat">
                    <div className="hseq-stat-title">Total empleados</div>
                    <div className="hseq-stat-value">{totalEmpleados}</div>
                  </div>
                  <div className="hseq-stat">
                    <div className="hseq-stat-title">Evaluados HSEQ ({anioActual})</div>
                    <div className="hseq-stat-value">{evaluadosGlobal}</div>
                  </div>
                  <div className="hseq-stat">
                    <div className="hseq-stat-title">Pendientes HSEQ ({anioActual})</div>
                    <div className="hseq-stat-value">{pendientesGlobal}</div>
                  </div>
                  <div className="hseq-stat">
                    <div className="hseq-stat-title">Avance del período</div>
                    <div className="hseq-progress" aria-label={`Avance ${porcentajeCompletado}%`}>
                      <div className="hseq-progress-bar" style={{ width: `${porcentajeCompletado}%` }} />
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between', fontSize:'12px', color:'#6b7280', marginTop:'6px' }}>
                      <span>Completado: {porcentajeCompletado}%</span>
                      <span>Pendiente: {porcentajePendiente}%</span>
                    </div>
                  </div>
                </div>

                <div style={{ width:'100%', overflowX:'auto', border:'1px solid #e5e7eb', borderRadius:'10px' }}>
                  <table className="hseq-dash-table">
                    <thead>
                      <tr>
                        <th>Empleado</th>
                        <th>Estado</th>
                        <th>Evaluador HSEQ</th>
                        <th>Fecha</th>
                        <th style={{ textAlign:'right' }}>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {empleadosFiltrados.map(emp => {
                        const info = hseqGlobalMap[Number(emp.id_empleado)];
                        const estadoOk = Boolean(info && String(info.estado_evaluacion).toUpperCase() === 'COMPLETADA');
                        const fecha = info && info.fecha_evaluacion ? new Date(info.fecha_evaluacion) : null;
                        return (
                          <tr key={`row-${emp.id_empleado}`}>
                            <td style={{ whiteSpace:'nowrap' }}>{emp.nombre}</td>
                            <td>
                              <span className={`badge ${estadoOk ? 'badge-ok' : 'badge-pend'}`}>
                                {estadoOk ? 'Completada' : 'Pendiente'}
                              </span>
                            </td>
                            <td>{info?.evaluador_nombre || '-'}</td>
                            <td>{fecha ? fecha.toLocaleDateString() : '-'}</td>
                            <td style={{ textAlign:'right' }}>
                              <button
                                onClick={()=> goToEvaluate(emp)}
                                style={{
                                  background: 'linear-gradient(135deg, #1F3B73, #0A0F1A)',
                                  color: '#fff', border:'none', borderRadius:'6px', padding:'8px 12px', cursor:'pointer'
                                }}
                              >
                                Evaluar
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      {empleadosFiltrados.length === 0 && (
                        <tr>
                          <td colSpan={5} style={{ textAlign:'center', color:'#6b7280', padding:'16px' }}>Sin resultados</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div style={{ textAlign:'right', marginTop:'8px' }}>
                  <button className="dash-toggle" onClick={()=> setIsDashboardCollapsed(true)}>Ocultar dashboard</button>
                </div>
              </div>
            )}
            {!loading && !error && !selectedEmployee && isDashboardCollapsed && (
              <div style={{ marginTop:'8px', textAlign:'right' }}>
                <button className="dash-toggle" onClick={()=> setIsDashboardCollapsed(false)}>Mostrar dashboard</button>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
      </div>
    </>
  );
}

export default HseqEvaluation;


